import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from 'components/Page';
import store from 'store';

import AcademyReworkingBooking from './components/Booking';

function AppointmentsPage() {
	const { t } = useTranslation();
	const { student } = store.profile;

	return (
		<Page type="list" title={t('academyReworkings.main')} sx={{ minWidth: 0 }}>
			<AcademyReworkingBooking
				key={student?.id}
				studentId={student?.id}
				studentName={student?.first_name || store.profile.first_name || ''}
				phone={store.profile.phone}
				locations={store.profile.serviceLocations.map((location) => ({
					id: location.id,
					name: location.name,
				}))}
				groups={(student?.groups || [])
					.filter((group: any) => group.service_id === 1 && group.location?.id)
					.map((group: any) => ({
						id: group.id,
						name: group.name,
						locationId: group.location.id,
					}))}
				onBooked={() => store.modalNotifications.fetch({ service_id: 1, is_modal: 1 })}
			/>
		</Page>
	);
}

export default observer(AppointmentsPage);
